/**
 * eagleeyejssdk
 */
import * as Sentry from '@sentry/browser';
import config from '../../config';
import * as utilCookie from '../cookie';

const SENTRY_LEVEL_MAP_CONSOLE = {
  debug: 'debug',
  info: 'info',
  warning: 'warn',
  error: 'error'
};

// configureScope
// beforeSend

Sentry.init({
  dsn: config.sentry.dsn,
  environment: config.env,
  release: config.version,
  beforeSend(event, hint) {
    // 支持`error`对象定义`fingerprint`属性
    if (hint.originalException && hint.originalException.fingerprint) {
      const fingerprint = hint.originalException.fingerprint;
      event.fingerprint = typeof fingerprint === 'string' ? [fingerprint] : fingerprint;
    }

    return event;
  }

});

Sentry.configureScope((scope) => {
  scope.setUser({
    id: utilCookie.get('cdb_uid'),
    user_action_id: utilCookie.get('user_action_id')
  });
});


function setScope(scope, options = {}) {
  if (options.extras && typeof options.extras === 'object') {
    Object.keys(options.extras).forEach((key) => {
      scope.setExtra(key, options.extras[key]);
    });
  }

  if (options.tags && options.tags === 'object') {
    Object.keys(options.tags).forEach((key) => {
      scope.setTag(key, options.tags[key]);
    });
  }

  if (options.fingerprint) {
    scope.setFingerprint(options.fingerprint);
  }
}

export function error(error, options = {}) {
  Sentry.withScope((scope) => {
    setScope(scope, options);

    Sentry.captureException(error);
  });

  // eslint-disable-next-line
  console.error(error); // 打印到控制台
}

function log(message, level, options) {
  Sentry.withScope((scope) => {
    setScope(scope, options);

    Sentry.captureMessage(message, level);
  });

  const CONSOLE_LEVEL = SENTRY_LEVEL_MAP_CONSOLE[level] || 'log';
  // eslint-disable-next-line
  if (console[CONSOLE_LEVEL]) {
    // eslint-disable-next-line
    console[CONSOLE_LEVEL](message); // 打印到控制台
  }
}


export function warn(message, options = {}) {
  log(message, 'warning', options);
}

window.logger = {
  error, warn
};
